export const BIG_ORBIT_COEFF = 0.8
export const SMALL_ORBIT_COEFF = 0.5

export const ICON_SIZE = 64
